/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const CHECKOUT_FEATURE = 'checkout';
export const CHECKOUT_CORE_FEATURE = 'checkoutCore';
